import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IServerSettings } from '../models/serversettings';

@Injectable()
export class SettingsService {
    public serverSettings: IServerSettings;

    constructor(private readonly httpService: HttpClient) { }

    getSettings(): IServerSettings {
        return this.serverSettings;
    }

    get identityServiceUrl() {
        return this.serverSettings.IdentityServiceUrl;
    }

    get sessionTimout() {
        return this.serverSettings.SessionTimeout;
    }

    get absoluteSessionTimeout() {
        return this.serverSettings.AbsoluteSessionTimeout;
    }
    // Flag for turning on/off DataDog RUM monitor
    get dataDogEnabled() {
      return this.serverSettings.DataDogEnabled;
    }

    // DataDog application ID
    get dataDogApplicationId() {
      return this.serverSettings.DataDogApplicationId;
    }

    // DataDog Client Token
    get dataDogClientToken() {
      return this.serverSettings.DataDogClientToken;
    }

    // DataDog Service Name
    get DataDogService() {
      return this.serverSettings.DataDogService;
    }

    // DataDog Site url
    get dataDogSite() {
      return this.serverSettings.DataDogSite;
    }

    // DataDog version
    get dataDogVersion() {
      return this.serverSettings.DataDogVersion;
    }

    // DataDog environment
    get dataDogEnv() {
      return this.serverSettings.DataDogEnv;
    }

    // DataDog Sample Rate
    get dataDogSampleRate() {
      return this.serverSettings.DataDogSampleRate;
    }

    // DataDog TrackInteractions flag
    get dataDogTrackInteractions() {
      return this.serverSettings.DataDogTrackInteractions;
    }

    // DataDog allowedTracingOrigins flag
    get dataDogAllowedTracingOrigins() {
      return this.serverSettings.DataDogAllowedTracingOrigins;
  }

  // OneTrust domainTokenId
    get oneTrustDomainToken() {
      return this.serverSettings.OneTrustDomainToken;
    }
}
